import type { Objection } from '../types/content'

export const objections: Objection[] = [
  {
    id: 'precio',
    question: '"¿Por qué es tan barato si vale tanto?"',
    answer:
      'Porque una vez que vea el ahorro en su primera compra de farmacia, usted será cliente mío de por vida para mis protocolos avanzados. Esto es un "soborno ético" para demostrarle que sé de lo que hablo. Si cobrara $500, muchos dudarían. A $37, quien duda tiene un problema de lógica, no de dinero.'
  },
  {
    id: 'pais',
    question: '"¿Esto funciona en mi país?"',
    answer:
      'El protocolo cubre los hubs mundiales (USA, México, España, Colombia). Si vive en un lugar con farmacias especializadas, esto funciona. Si no, el Bonus 15 le enseña a traerlo legalmente.'
  },
  {
    id: 'conocimiento',
    question: '"No sé nada de medicina, ¿es para mí?"',
    answer:
      'Precisamente. Está escrito para ejecutivos ocupados, no para médicos. Es "copy-paste". Si sabe seguir una receta de cocina, sabe hackear su biología con esto.'
  }
]
